// extracted by mini-css-extract-plugin
module.exports = {"tumor-input-number-wrapper":"TumorInfoPercent_tumor-input-number-wrapper__2Bhfm"};